let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("53hH3")).then(() => parcelRequire('kKp2J'));